/** Client-side downscale before upload — normalizes to JPEG and avoids huge phone originals. */
export async function compressImageForUpload(file: Blob, maxDimension: number): Promise<File> {
    const inputFile = file instanceof File ? file : new File([file], "photo.jpg", { type: file.type || "image/jpeg" });
    if (maxDimension <= 0) return inputFile;

    try {
        const bitmap = await createImageBitmap(file);
        const longest = Math.max(bitmap.width, bitmap.height);
        if (longest <= maxDimension && file.type === "image/jpeg" && file instanceof File) {
            bitmap.close();
            return file;
        }

        const scale = Math.min(1, maxDimension / longest);
        const width = Math.max(1, Math.round(bitmap.width * scale));
        const height = Math.max(1, Math.round(bitmap.height * scale));

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
            bitmap.close();
            return inputFile;
        }

        ctx.drawImage(bitmap, 0, 0, width, height);
        bitmap.close();

        const blob = await new Promise<Blob | null>((resolve) => {
            canvas.toBlob(resolve, "image/jpeg", 0.85);
        });
        if (!blob) return inputFile;

        const baseName = file instanceof File ? file.name.replace(/\.[^.]+$/, "") : "photo";
        return new File([blob], `${baseName}.jpg`, {
            type: "image/jpeg",
            lastModified: Date.now(),
        });
    } catch {
        return inputFile;
    }
}
